import type { RecentSearch } from '../types';
import {
    TOGGLE_SEARCH_SIDEBAR_VISIBILITY,
    ADD_SEARCH_TERM,
    ADD_RECENT_SEARCH,
    ADD_SEARCH_RESULTS,
    OVERRIDE_RECENT_SEARCHES,
    DELETE_ALL_RECENT_SEARCHES,
} from './constants';

export const toggleSearchSidebarVisibility = (state: boolean) => ({
    type: TOGGLE_SEARCH_SIDEBAR_VISIBILITY,
    payload: state,
});

export const addSearchTerm = (search: string) => ({
    type: ADD_SEARCH_TERM,
    payload: search,
});

export const addRecentSearch = (recentSearch: RecentSearch) => ({
    type: ADD_RECENT_SEARCH,
    payload: recentSearch,
});

export const addSearchResults = (searchResults: any) => ({
    type: ADD_SEARCH_RESULTS,
    payload: searchResults,
});

export const overrideRecentSearches = (recentSearches: RecentSearch) => ({
    type: OVERRIDE_RECENT_SEARCHES,
    payload: recentSearches,
});

export const deleteAllRecentSearches = () => ({
    type: DELETE_ALL_RECENT_SEARCHES,
});
